import { useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import LoadingBar from "react-top-loading-bar";
import { toast } from "react-toastify";
import { useTranslation, Trans } from "react-i18next";
import { API_BASE_URL } from "../api";
import Form from "../components/Form/Form";
import InputText from "../components/Form/Fields/InputText";
import LanguageSelector from "../components/LanguageSelector/LanguageSelector";
import './Login.scss';

export default function ForgotPassword() {
  const { t, i18n } = useTranslation();
  const isRtl = document.documentElement.dir === 'rtl';
  const [sentEmail, setSentEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  const handleSubmit = async (data) => {
    ref.current.continuousStart();
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { email: data.email });
      setSentEmail(data.email);
      setSent(true);
      ref.current.complete();
    } catch {
      toast.error(t("forgot_password.error"));
      ref.current.complete();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoadingBar color="#2563eb" ref={ref} height={3} shadow />

      <div className="container-fluid min-vh-100 d-flex p-0 login-wrapper">
        <div className="d-flex flex-column justify-content-center align-items-center px-5 form-side">
          <div className="w-100" style={{ maxWidth: 450 }}>

            <div className="text-center mb-4">
              <NavLink to={`/${i18n.language}`}>
                <img src="/images/saydalani_logo.png" alt="Saydalani" style={{ height: 31 }} className="mb-4" />
              </NavLink>
              <h3 className="fw-bold mt-3 mb-2 welcome_back_title">{t("forgot_password.title")}</h3>
              <p className="text-muted" style={{ fontSize: 14 }}>
                {sent ? t("forgot_password.check_inbox") : t("forgot_password.subtitle")}
              </p>
            </div>

            {sent ? (
              <div style={{
                background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10,
                padding: "20px 24px", textAlign: "center", marginBottom: 24,
              }}>
                <div style={{ fontSize: 32, marginBottom: 10 }}>📬</div>
                <p style={{ fontSize: 14, color: "#166534", margin: 0 }}>
                  <Trans i18nKey="forgot_password.sent_message" values={{ email: sentEmail }} components={{ 1: <strong /> }} />
                </p>
              </div>
            ) : (
              <Form id="forgotPasswordForm" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <div className="form-floating mb-4">
                    <InputText
                      id="email"
                      name="email"
                      type="email"
                      disabled={loading}
                      validationRules={{ required: t('login.email_required') }}
                      autofocus={true}
                      autoComplete="email"
                    />
                    <label htmlFor="email" className="form-label">{t("forgot_password.email_label")}</label>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-dark btn-lg w-100 rounded-pill py-2"
                  style={{ fontSize: 16, fontWeight: 600 }}
                  disabled={loading}
                >
                  {loading ? <span className="spinner-border spinner-border-sm me-2" /> : null}
                  {t("forgot_password.send_link")}
                </button>
              </Form>
            )}

            <div className="text-center mt-4">
              <NavLink to={`/${i18n.language}/login`} style={{ fontSize: 13, color: "#6b7280", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
                <FontAwesomeIcon icon={isRtl ? faArrowRight : faArrowLeft} style={{ fontSize: 11 }} />
                {t("forgot_password.back_to_login")}
              </NavLink>
            </div>

            <div className="text-center text-white login_footer small mt-4">
              <div className="d-flex justify-content-center" style={{ marginBottom: 20 }}>
                <LanguageSelector className="login-lang-selector" />
              </div>
              <p className="small mb-2">{t('landing.footer.copyright', { year: new Date().getFullYear() })}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
